<!-- 上传课件 -->
<template>
  <div v-loading="loading" class="editSublet">
    <header class="header">
      <span>新建/编辑作业分组</span>
      <!-- <el-button type="primary">保存</el-button> -->
    </header>
    <div>
      <el-form :model="announcement" ref="announcement" label-width="150px">
        <el-form-item
          label="分组名称"
          prop="workGroupName"
          :rules="[{ required: true, message: '分组名称不能为空'}]"
        >
          <el-input
            type="text"
            v-model="announcement.workGroupName"
            :maxlength="50"
            placeholder="请输入课件名称"
            style="width:480px;"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="授课班级"
          prop="courseId"
          :rules="[{ required: true, message: '可见授课班级不能为空'}]"
        >
          <el-select v-model="announcement.courseId" placeholder="请选择" @change="changeCourse">
            <el-option label="暂无数据" :value="0" v-if="cities.length==0"></el-option>
            <el-option v-for="item in cities" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <span
            style="font-size: 16px;
    font-weight: 700;
    color: red;
    padding-left: 20px;"
          >班级总人数：{{total}}</span>
        </el-form-item>
        <el-form-item
          label="最大小组数量"
          prop="maxGroup"
          :rules="[{ required: true, message: '最大小组数量不能为空'}]"
        >
          <el-input
            type="text"
            v-model="announcement.maxGroup"
            :maxlength="50"
            placeholder="请输入最大小组数量"
            style="width:180px;"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="最大小组人数"
          prop="maxNum"
          :rules="[{ required: true, message: '最大小组人数不能为空'}]"
        >
          <el-input
            type="text"
            v-model="announcement.maxNum"
            :maxlength="50"
            placeholder="请输入最大小组人数"
            style="width:180px;"
          ></el-input>
        </el-form-item>

        <el-form-item label="分组方式" prop="type" :rules="[{ required: true, message: '分组方式不能为空'}]">
          <el-radio-group v-model="announcement.type">
            <!-- <el-radio label="1">自组</el-radio> -->
            <el-radio label="2">随机</el-radio>
          </el-radio-group>
          <el-button
            style="margin-left: 20px;"
            @click="previewGroup" :disabled="announcement.type!=2"
            type="primary"
            size="mini"
          >生成分组</el-button>
        </el-form-item>

        <el-form-item
          label="生成分组"
          prop="groupMemberTOS"
          :rules="[{ required: true, message: '生成分组不能为空'}]"
          v-if="announcement.type==2"
        >
          <div style="width: 600px;">
            <el-table :data="tableData" height="450" border>
              <el-table-column fixed prop="groupNo" label="小组编号"></el-table-column>
              <el-table-column fixed prop="studentName" label="考生姓名">
                <template slot-scope="scope">
                  {{scope.row.studentName}}
                  <span v-if="scope.row.type==1">(组长)</span>
                </template>
              </el-table-column>
              <el-table-column fixed prop="licenseNo" label="学号"></el-table-column>
              <el-table-column fixed prop="className" label="班级"></el-table-column>
            </el-table>
          </div>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('announcement')">提交</el-button>
          <el-button @click="$router.go(-1)">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import UpFile from "../common/uploadFile";
import richEditor from "@/components/common/RichEditor.vue";
export default {
  components: {
    richEditor,
    UpFile
  },
  data() {
    return {
      tableData: [],
      total: this.$route.query.total, // 总人数

      loading: false,
      checkAll: false,
      cities: [], // 总数据
      isIndeterminate: false,

      param: {
        schoolId: this.$route.query.schoolId,
        teacherId: this.$route.query.teacherId
      }, // 可见授课班级
      announcement: {
        schoolId: this.$route.query.schoolId,
        courseId: Number(this.$route.query.courseId), // 课程ID
        groupMemberTOS: [
          // {
          //   groupNo: 0, // 小组编号
          //   studentId: 0, // 学生id
          //   type: 0 // 0普通成员 1组长
          // }
        ],
        maxGroup: null, // 最大小组数量
        maxNum: null, //最大小组人数
        type: null, // 分组类型 1:自组 2：随机
        workGroupName: "" // 组配置名称
      }
    };
  },

  created() {
    this.getCourseSummaryList();
  },
  methods: {
// 授课班级
    changeCourse() {
      const param = {
        courseId: this.announcement.courseId,
        schoolId: this.$route.query.schoolId
      };
      this.loading = true;
      this.$api.allianceSchool.getCourseGroup(param).then(res => {
        this.loading = false;
        if (res.errCode == 0) {
          this.total = res.data.total
        } else {
          this.$message.error(res.errMsg);
        }
      }).catch(res=>{
        this.loading = false;
      });
    },

    // 随机生成分组情况
    previewGroup() {
      const param = {
        courseId: this.announcement.courseId,
        maxGroup: this.announcement.maxGroup,
        maxNum: this.announcement.maxNum,
        schoolId: this.$route.query.schoolId
      };
      if (!param.maxGroup) {
        this.$message.error("最大小组数量");
        return;
      } else if (!param.maxNum) {
        this.$message.error("最大小组人数");
        return;
      } else if (!param.courseId) {
        this.$message.error("请选择授课班级");
        return;
      }
      this.loading = true;
      this.$api.allianceSchool.previewGroup(param).then(res => {
        this.loading = false;
        if (res.errCode == 0) {
          this.tableData = res.data;
          this.announcement.groupMemberTOS = [];
          res.data.forEach((element, idx) => {
            this.announcement.groupMemberTOS.push({
              groupNo: element.groupNo, // 小组编号
              studentId: element.studentId, // 学生id
              type: element.type // 0普通成员 1组长
            });
          });
        } else {
          this.$message.error(res.errMsg);
        }
      }).catch(res=>{
        this.loading = false;
      });
    },
    // 保存
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          this.$api.allianceSchool
            .creatCourseGroup(this.announcement)
            .then(res => {
              this.loading = false;
              if (res.errCode == 0) {
                this.$router.go(-1)
              } else {
                this.$message.error(res.errMsg);
              }
            }).catch(res=>{
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除文件
    delFile(item, idx) {
      const than = this;
      this.$confirm("您确认删除吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
          than.announcement.attachmentTOS.splice(idx, 1);
      });
    },
    // 上传
    onFileUpLoad(res) {
      const param = {
        name: res.file.name,
        size: (res.file.size / 1024).toFixed(2),
        url: res.item.url
      };
      this.announcement.attachmentTOS.push(param);
    },
    // 获取可见授课班级
    getCourseSummaryList() {
      this.loading = true;
      this.$api.allianceSchool.getCourseSummaryList(this.param).then(res => {
        this.loading = false;
        if (res.errCode == 0) {
          this.cities = res.data;
        } else {
          this.$message.error(res.errMsg);
        }
      }).catch(res=>{
        this.loading = false;
      });
    }
  }
};
</script>
<style lang='less' scoped>
.editSublet {
  background: #fff;
  padding: 10px;
  box-sizing: border-box;
  header {
    span {
      font-size:16px;
      font-family:PingFang-SC;
      color:#424346;
    }
  }
}
.delete {
  font-size: 20px;
  color: red;
  cursor: pointer;
  padding-left: 10px;
}
</style>